import "./LevelOfPainComponent.scss";
import {useCallback} from "react";
import {FieldProps} from "formik";

interface LevelOfPainComponentProps {
    value?: any;
    onUpdate?: (text: any) => void;
    formikField: FieldProps;
    label?: string;
}

const list = [
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]
const LevelOfPainComponent = (props: LevelOfPainComponentProps) => {
    const {formikField, onUpdate, label} = props;

    const {field, form} = formikField;
    const {name, value} = field;
    const {setFieldTouched, setFieldValue} = form;


    const handleSelectedLevel = useCallback((value: any) => {
        let tempValue = value;
        setFieldValue(name, tempValue);
        setFieldTouched(name);
        if (onUpdate) {
            onUpdate(tempValue)
        }
    }, [name, onUpdate, setFieldTouched, setFieldValue]);

    return (
        <> {label && <div className={'level-of-pain-label'}>{label}</div>}
            <div className={'level-of-pain-component'}>
                {
                    list.map((item, index) => {
                        return <>
                            <div className={'pain-component-wrapper'}>
                                <div
                                    className={`level-of-pain-item ${value === index ? 'selected' : ''} ${index >= 10 ? ' big' : ''}`}
                                    key={index}
                                    onClick={() => {
                                        handleSelectedLevel(index);
                                    }}
                                >
                                    <div className={"level-of-pain-item-value"}>{item}</div>
                                </div>
                                {index === 0 &&
                                    <div className={'pain-text mrg-top-10'}>No <br/>pain</div>
                                }
                                {index === 5 &&
                                    <div className={'pain-text mrg-top-10'}>Moderate
                                        <br/>pain</div>
                                }
                                {index === 10 &&
                                    <div className={'pain-text mrg-top-10'}>Worst <br/> possible <br/> pain</div>
                                }
                            </div>

                        </>
                    })
                }
            </div>
        </>
    );

};

export default LevelOfPainComponent;
